import { render, staticRenderFns } from "./ListHeaderDesktop.vue?vue&type=template&id=53e23fbb&scoped=true&"
import script from "./ListHeaderDesktop.vue?vue&type=script&lang=js&"
export * from "./ListHeaderDesktop.vue?vue&type=script&lang=js&"
import style0 from "./ListHeaderDesktop.vue?vue&type=style&index=0&id=53e23fbb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e23fbb",
  null
  
)

export default component.exports